import { stateStrategy, translateStateStrategy } from '../constants/stateStrategy.constant'
import { PublicCompanyLeadData } from '../types/publicCompanyLead'

export const publicCompanyLeadsTransformer = (clients: PublicCompanyLeadData[]) => {
  return clients
    .map((client) => ({ ...client, state: stateStrategy[client.state] }))
    .reduce((acc, curr) => ({ ...acc, [curr.state]: [...acc[curr.state], curr] }), {
      registered: [],
      qualifying: [],
      certame: [],
      negotiating: [],
      implantation: [],
      completed: [],
    })
}

export const publicCompanyLeadsQuickSearchModelTransformer = () => {
  return (clients: PublicCompanyLeadData[]) => {
    return clients.map((client) => ({
      route: `/public-clients/${client.id}/edit`,
      items: [
        ['Nome da empresa', client.display_name],
        ['Etapa', translateStateStrategy[stateStrategy[client.state]]],
        ['Descrição', client.last_state_change_log?.message],
      ]
    }));
  };
}

